module.exports = __webpack_public_path__ + "static/img/gaoxin.8be35872.jpg";